import React, { Component } from 'react';
import HomePageText from './homePageText';
import Categories from './categories';
import FeaturedProducts from './featuredProducts';
import MainHistoryBlock from './mainHistoryBlock';
import AppBlock from './appBlock';
import Hero from './hero';

class Home extends Component {
  state = {};

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = 'Beverix';
  }

  render() {
    return (
      <React.Fragment>
        <Hero />
        <HomePageText />
        <Categories />
        <FeaturedProducts />
        <MainHistoryBlock />
        <AppBlock />
      </React.Fragment>
    );
  }
}

export default Home;
